export default function (hooks) {
    return function onEnter(nextState, replace, callback) {
        (function executeHooksSynchronously(remainingHooks) {
            if (!remainingHooks.length) {
                return callback();
            }
            const nextHook = remainingHooks[0];
            if (nextHook.length >= 3) {
                nextHook.call(this, nextState, replace, () => {
                    executeHooksSynchronously(remainingHooks.slice(1));
                });
            } else {
                nextHook.call(this, nextState, replace);
                executeHooksSynchronously(remainingHooks.slice(1));
            }
            return null;
        })(hooks);
    };
}

export function chainOnChangeMiddeware(hooks) {
    return function onChange(prevState, nextState, replace, callback) {
        (function executeHooksSynchronously(remainingHooks) {
            if (!remainingHooks.length) {
                return callback();
            }
            const nextHook = remainingHooks[0];
            if (nextHook.length >= 3) {
                nextHook.call(this, prevState, nextState, replace, () => {
                    executeHooksSynchronously(remainingHooks.slice(1));
                });
            } else {
                nextHook.call(this, prevState, nextState, replace);
                executeHooksSynchronously(remainingHooks.slice(1));
            }
            return null;
        })(hooks);
    };
}
